<template>
    <side-panel
        id="main-panel"
        :class="{
            collapsed: mainCollapsed,
            'table-variant': vehicleListModeView == 'table' && !mainCollapsed,
            'table-fluid': fluidTable,
            'with-activity-open': activityPanelOpen
        }"
        :scrollable-body="vehicleListModeView != 'table'"
    >
        <template #head>
            <golia-button
                @click="scrollTopVehicles"
                class="btn-scroll-vehicles"
                :class="pinEvent ? 'animated' : ''"
                :label="__('geofleet.mainpanel.pinned_vehicles')"
                variant="btn-fill success"
                icon="fa-circle-chevron-up"
                iconPosition="right"
            />

            <transition name="collapse-fade" mode="in-out">
                <div v-show="!mainCollapsed" :class="{ 'form-section': true }">
                    <ul class="icons-list list-inline text-center">
                        <!-- Search vehicles -->
                        <li
                            class="list-inline-item position-relative"
                            v-b-tooltip.hover
                            :title="__('search_vehicle')"
                        >
                            <div class="icon-indicator" v-show="q">
                                <i class="fa-solid fa-check"></i>
                            </div>
                            <button v-b-toggle.collapse-search class="btn btn-transparent rounded">
                                <i class="fa-solid fa-magnifying-glass"></i>
                            </button>
                        </li>
                        <!-- Sort vehicles -->
                        <li
                            class="list-inline-item position-relative"
                            v-b-tooltip.hover
                            :title="__('sort_vehicles')"
                            v-if="vehicleListModeView != 'table'"
                        >
                            <div
                                class="icon-indicator"
                                v-if="countEntries(sort, 'active', true) > 0"
                            >
                                {{ countEntries(sort, 'active', true) }}
                            </div>
                            <button v-b-toggle.collapse-sort class="btn btn-transparent rounded">
                                <i class="fa-solid fa-arrow-down-a-z"></i>
                            </button>
                        </li>
                        <!-- Multicompany -->
                        <li
                            class="list-inline-item position-relative"
                            v-if="Object.keys(effectiveCompanies).length > 1"
                            v-b-tooltip.hover
                            :title="__('multicompany')"
                        >
                            <div class="icon-indicator">
                                {{ Object.keys(effectiveCompanies).length }}
                            </div>
                            <button
                                v-b-toggle.collapse-multiazienda
                                class="btn btn-transparent rounded"
                            >
                                <i class="fa-solid fa-buildings"></i>
                            </button>
                        </li>

                        <!-- Table Settings -->
                        <li
                            class="list-inline-item position-relative"
                            v-b-tooltip.hover
                            :title="__('vehicle_list_settings')"
                        >
                            <table-settings></table-settings>
                        </li>
                    </ul>

                    <!-- Search vehicles collapse -->
                    <b-collapse id="collapse-search" accordion="icons-header" visible>
                        <div class="d-flex align-items-center" style="gap: 10px">
                            <div class="flex-grow-1">
                                <input-search
                                    v-model="q"
                                    @resetSearch="resetSearch"
                                    ref="search_input"
                                />
                            </div>
                            <div class="d-flex flex-grow-0">
                                <!-- FILTERS BUTTON -->
                                <golia-button
                                    variant="btn-circle btn-fill dark-blue"
                                    icon="fa-fw fa-filter"
                                    :indicator="activeSearches"
                                    style="margin-bottom: 10px; padding: 5px 7px"
                                    v-b-modal.modal-search-trucks
                                />

                                <!-- QUICK ALERTS FILTER -->
                                <golia-button
                                    variant="btn-circle btn-fill"
                                    :class="{
                                        'dark-blue': !activeFilters.any_problem,
                                        success: activeFilters.any_problem
                                    }"
                                    icon="fa-fw fa-triangle-exclamation"
                                    :indicator="getTrucksWithAlerts.length"
                                    style="margin-bottom: 10px; margin-left: 10px; padding: 5px 7px"
                                    @click="triggerFilter('any_problem')"
                                />

                                <template v-if="vehicleListModeView == 'table'">
                                    <!-- Quick Filters -->
                                    <golia-button
                                        variant="btn-circle btn-fill dark-blue ms-2"
                                        icon-weight="fak"
                                        icon="fa-fw fa-user-nocard"
                                        :indicator="activeFilters.no_card ? 1 : 0"
                                        style="margin-bottom: 10px; padding: 5px 7px"
                                        @click="triggerFilter('no_card')"
                                        v-b-tooltip.left.hover
                                        :title="__('no_card')"
                                    />
                                    <golia-button
                                        variant="btn-circle btn-fill dark-blue ms-2"
                                        icon="fa-fw fa-user-group"
                                        :indicator="activeFilters.codriving ? 1 : 0"
                                        style="margin-bottom: 10px; padding: 5px 7px"
                                        @click="triggerFilter('codriving')"
                                        v-b-tooltip.left.hover
                                        :title="__('codriving')"
                                    />
                                    <golia-button
                                        variant="btn-circle btn-fill dark-blue ms-2"
                                        icon="fa-fw fa-lightbulb"
                                        :indicator="activeFilters.ignition ? 1 : 0"
                                        style="margin-bottom: 10px; padding: 5px 7px"
                                        @click="triggerFilter('ignition')"
                                        v-b-tooltip.left.hover
                                        :title="__('ignition')"
                                    />
                                </template>
                            </div>
                        </div>
                    </b-collapse>

                    <!-- Filter modal -->
                    <b-modal
                        id="modal-search-trucks"
                        :title="__('geofleet.mainpanel.search_trucks_title')"
                        size="lg"
                        @show="loadPoiFilterData"
                        @hidden="filterActiveTab = 0"
                    >
                        <filter-trucks
                            :nearVehicles="nearVehicles"
                            :activeTab.sync="filterActiveTab"
                            v-model="activeFilters"
                            @filters-change="scheduleFilterTrucks"
                        />

                        <template #modal-footer="{}">
                            <!-- Chiude modale / Torna indietro -->
                            <golia-button
                                :label="__('cerca')"
                                :loading="
                                    nearVehicles.active && nearVehicles.searchedVehicles.length == 0
                                "
                                @click="
                                    filterTrucks(true),
                                        truck_filtered_out.length > 0
                                            ? $snotify.success(__('filter_applied'), {
                                                  position: 'centerTop'
                                              })
                                            : ''
                                "
                                icon="fa-magnifying-glass"
                                variant="btn-success"
                            />
                            <golia-button
                                :label="__('erase')"
                                @click="resetFilerFields()"
                                icon="fa-eraser"
                                variant="btn-fill gray"
                                class="ms-2"
                            />
                            <golia-button
                                :label="__('cancel_search')"
                                @click="
                                    resetFilerFields() && $bvModal.hide('modal-search-trucks'),
                                        $snotify.info(__('filter_canceled'), {
                                            position: 'centerTop'
                                        })
                                "
                                icon="fa-filter-circle-xmark"
                                variant="btn-fill dark-blue"
                                class="ms-auto"
                            />
                        </template>
                    </b-modal>

                    <!-- Sort vehicles collapse -->
                    <b-collapse id="collapse-sort" accordion="icons-header">
                        <div class="container-fluid modified-gutters">
                            <sort-trucks
                                :sort="sort"
                                :sortAction="sortAction"
                                @sortToggle="toggleSorter"
                                ref="sort_input"
                            />
                        </div>
                    </b-collapse>

                    <!-- Multicompany collapse -->
                    <b-collapse
                        id="collapse-multiazienda"
                        accordion="icons-header"
                        v-if="Object.keys(effectiveCompanies).length > 1"
                    >
                        <div class="container-fluid modified-gutters custom-scrollbar">
                            <div
                                class="single-toggle d-flex justify-content-between align-items-center"
                                v-for="(company, index) in filterCompanies"
                                :key="index"
                                :class="{
                                    active: company.active === true,
                                    'text-tiny': Object.keys(effectiveCompanies).length > 10
                                }"
                                @click="company.active = !company.active"
                            >
                                {{ company.name }} ({{ companyCounts[index] }})
                                <i
                                    class="fa-solid"
                                    :class="company.active ? 'fa-check' : 'fa-xmark'"
                                ></i>
                            </div>
                        </div>
                    </b-collapse>

                    <p class="text-center mb-0" v-if="!mainCollapsed">
                        <small
                            ><b>{{ __('vehicles') }}: </b>
                            <span
                                :class="truck_filtered_out.length > 0 ? 'text-success' : ''"
                                v-if="truck_filtered_out.length"
                            >
                                {{ storeTrucks.length - truck_filtered_out.length }} /
                            </span>
                        </small>
                        <small>{{ storeTrucks.length }}</small>
                    </p>
                </div>
            </transition>

            <div
                @click="toggleCollapsePanel({ panel: 'main' })"
                class="collapse-button"
                v-if="$mq != 'xs' && $mq != 'sm'"
            >
                <i v-if="mainCollapsed" class="fa-solid fa-arrow-left-from-line"></i>
                <i v-else class="fa-solid fa-arrow-right-from-line"></i>
            </div>

            <!-- Mobile close button (return to home) -->
            <div
                @click="$router.push({ name: 'geofleet.index' })"
                class="close-btn"
                v-if="($mq == 'xs' || $mq == 'sm') && direction != 'horizontal'"
            >
                <i class="fa-solid fa-xmark"></i>
            </div>
        </template>

        <template #body>
            <template v-if="vehicleListModeView == 'table' && !mainCollapsed">
                <trucks-table
                    :trucks="listActiveTrucks"
                    :sortAction="sortAction"
                    @focus="(truck) => emitFocusEvent(truck)"
                    @plan="emitPlanEvent"
                    @activity="emitActivityEvent"
                />
            </template>
            <template v-else>
                <dynamic-scroller
                    :items="listActiveTrucks"
                    :min-item-size="direction === 'horizontal' || mainCollapsed ? 75 : 100"
                    :buffer="500"
                    :direction="direction"
                    key-field="id"
                    class="truck-section custom-scroller scroller"
                    ref="dynamic-truck-scroller"
                >
                    <template #before>
                        <golia-button
                            class="btn-close-scroll-vehicles"
                            :label="__('geofleet.mainpanel.pinned_vehicles')"
                            variant="btn-fill gray fenced"
                            size="btn-sm"
                            :icon="!pinCollapse ? 'fa-chevron-up' : 'fa-chevron-down'"
                            iconPosition="right"
                            v-if="computedPinnedTrucks.length > 0"
                            v-show="!mainCollapsed"
                            v-b-toggle.pinned-vehicles
                            @click="pinCollapse = !pinCollapse"
                        />
                        <div v-if="computedPinnedTrucks.length > 0" class="pinned-vehicles">
                            <b-collapse id="pinned-vehicles" visible>
                                <truck-list-item
                                    class="truck-list-item"
                                    v-for="truck of computedPinnedTrucks"
                                    :key="truck.id"
                                    :truck="truck"
                                    :poi-names="truckPoiMemberships[truck.id] || []"
                                    :driver="effectiveDrivers?.[truck?.lastpoint?.driver]"
                                    :collapsed="mainCollapsed"
                                    @click="emitFocusEvent(truck)"
                                    @contextmenu="emitActivityEvent(truck)"
                                    @pinTruck="emitPinTruck(truck)"
                                    @detailTruckHooked="emitDetailTruckHooked"
                                    @manager="emitManagerEvent(truck)"
                                    @analyze="emitActivityEvent(truck)"
                                    @plan="emitPlanEvent(truck)"
                                    :id="'pinned-' + truck.id"
                                >
                                </truck-list-item>
                            </b-collapse>
                        </div>
                    </template>

                    <template v-slot="{ item, index, active }">
                        <dynamic-scroller-item
                            :item="item"
                            :active="active"
                            :data-index="index"
                            :size-dependencies="[
                                mainCollapsed,
                                vehicleIdentification,
                                (truckPoiMemberships[item.id] || []).join('|')
                            ]"
                        >
                            <truck-list-item
                                class="truck-list-item"
                                :truck="item"
                                :poi-names="truckPoiMemberships[item.id] || []"
                                :driver="effectiveDrivers?.[item?.lastpoint?.driver]"
                                :collapsed="mainCollapsed"
                                @click="emitFocusEvent(item)"
                                @contextmenu="emitActivityEvent(item)"
                                @pinTruck="emitPinTruck(item)"
                                @detailTruckHooked="emitDetailTruckHooked"
                                @manager="emitManagerEvent(item)"
                                @analyze="emitActivityEvent(item)"
                                @plan="emitPlanEvent(item)"
                            />
                        </dynamic-scroller-item>
                    </template>
                </dynamic-scroller>
            </template>

            <p class="p-3 text-center" v-if="countEntries(effectiveTrucks, 'visible', true) == 0">
                {{ __('no_vehicles_founded') }}
            </p>
        </template>
    </side-panel>
</template>

<script>
import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'

import SidePanel from '@/components/panels/SidePanel.vue'

//MAIN PANEL
import InputSearch from './MainPanel/InputSearch.vue'
import TruckListItem from './MainPanel/TruckListItem.vue'
import SortTrucks from './MainPanel/SortTrucks.vue'
import FilterTrucks from './MainPanel/FilterTrucks.vue'
import TrucksTable from './MainPanel/TrucksTable.vue'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import TableSettings from './MainPanel/TableSettings.vue'

import { mapState, mapGetters, mapMutations } from 'vuex'
import { mapConfig } from '@/composables/useConfig'

import { buildVehicleAlerts } from '@/functions/checkVehicleAlerts.js'
import { sortByKey } from '@/functions/sortTrucks.js'
import { isPointInsidePoi } from '@/functions/poiGeometry.js'

let defaultFilters = {
    // Vehicle
    tags: [],
    engine_rpm: 0,
    ignition: 0,
    moving: 0,
    // Alerts
    low_fuel: false,
    low_battery: false,
    tacho_overspeed: false,
    no_power_supply: false,
    no_gps: false,
    no_points: false,
    tacho_clock_error: false,
    // Driver
    activity: 4,
    no_card: false,
    codriving: false,
    residual_commitment_type: 'daily',
    residual_commitment: null,
    poi_category_id: null,
    poi_id: null,
    branches: [],
    sectors: []
}

export default {
    name: 'MainPanel',
    props: {
        trucks: {
            type: Array,
            required: false,
            default: () => []
        },
        drivers: {
            type: [Object, Array],
            required: false,
            default: () => {}
        },
        companies: {
            type: [Object, Array],
            required: false,
            default: () => {}
        },
        collapsed: {
            type: Boolean,
            default: false
        },
        last_update: {
            type: String,
            required: false
        },
        direction: {
            type: String,
            required: false,
            default: 'vertical'
        },
        // REFACTOR-007 (Sprint 7): la classe 'with-activity-open' sul root e' ora un
        // binding reattivo guidato da questo prop (GeoFleet lo setta dopo il delay di
        // animazione) invece di $refs.main_panel.$el.classList da GeoFleet. Default
        // false: viewSharedLink non passa il prop e non usa il pannello attivita'.
        activityPanelOpen: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        SidePanel,
        InputSearch,
        TruckListItem,
        SortTrucks,
        FilterTrucks,
        DynamicScroller,
        DynamicScrollerItem,
        TrucksTable,
        TableSettings
    },
    data() {
        return {
            q: null,
            q_fields: [
                'plate',
                'details.custom_id',
                'lastpoint.last_driver.name',
                'lastpoint.last_driver.surname',
                'details.brand',
                'details.model'
            ],

            pinEvent: false,
            pinCollapse: false,
            sort: {
                alphabetic: {
                    active: false,
                    order: 'asc',
                    fields: ['details.custom_id', 'plate'],
                    label: this.__('sort_for_alphanumeric')
                },
                cronological: {
                    active: false,
                    order: 'asc',
                    fields: ['lastpoint.date'],
                    label: this.__('sort_for_lastpoint')
                },
                company: {
                    active: false,
                    order: 'asc',
                    fields: ['details.company'],
                    label: this.__('sort_for_company')
                },
                activity: {
                    active: false,
                    order: 'asc',
                    fields: ['activity_type'],
                    label: this.__('sort_for_activity')
                }
            },
            sortAction: [],
            filterCompanies: {},

            filterSearchToggle: false,
            nearVehicles: {
                searchLocation: null,
                searchResults: [],
                searchedVehicles: [],
                areaSearch: null,
                areaUnit: 'km',
                active: false
            },
            // Active tab of the filter modal (.sync with FilterTrucks); set to 3
            // (the "Other" tab) when seeded via the map "find near vehicles".
            filterActiveTab: 0,
            activeFilters: {},
            truckPoiMemberships: {},

            // REFACTOR-009 (Fase 3): rimossi `localTrucks/localDrivers/localCompanies`.
            // Sostituiti dai computed `effectiveTrucks/Drivers/Companies` (vedi sezione
            // computed). Single source of truth = store (state.geoFleet.*), con override
            // tramite props (per casi sharedLink/embed che passano dati custom).

            ignore_scroll: false
        }
    },
    methods: {
        loadPoiFilterData() {
            if (this.poiCategories.length === 0) {
                this.$store.dispatch('loadPoiCategories', { vueInstance: this })
            }

            if (this.storePois.length === 0) {
                this.$store.dispatch('loadPois', { vueInstance: this })
            }
        },
        getActivePoiFilters() {
            if (this.activeFilters.poi_id != null && this.activeFilters.poi_id !== '') {
                return this.storePois.filter(
                    (poi) => String(poi.id) === String(this.activeFilters.poi_id)
                )
            }

            if (
                this.activeFilters.poi_category_id != null &&
                this.activeFilters.poi_category_id !== ''
            ) {
                return this.storePois.filter(
                    (poi) => String(poi.type) === String(this.activeFilters.poi_category_id)
                )
            }

            return []
        },
        getTruckMatchingPois(truck, pois) {
            if (!truck.lastpoint || pois.length === 0) return []

            return pois.filter((poi) =>
                isPointInsidePoi(truck.lastpoint.lat, truck.lastpoint.lng, poi)
            )
        },
        resetSearch() {
            this.q = null
        },
        scrollTopVehicles() {
            this.$refs['dynamic-truck-scroller'].scrollToItem(0)
        },
        // REFACTOR-009 (Fase 3): rimosso loadData() — il pattern "props o store"
        // è ora espresso dai computed effectiveTrucks/Drivers/Companies, reattivi
        // automaticamente senza bisogno di un mount-time copy.

        truckFocus(truck) {
            if (!this.ignore_scroll) {
                const index = this.listActiveTrucks.findIndex((item) => item.id === truck.id)

                if (index >= 0) {
                    this.$refs['dynamic-truck-scroller']?.scrollToItem(index)
                }
            }

            this.ignore_scroll = false
        },
        emitPinTruck(truck) {
            this.ignore_scroll = true

            truck.pinned = !truck.pinned

            if (!this.pinEvent) {
                this.pinEvent = true

                debounce(() => {
                    this.pinEvent = false

                    // Config Bus (Sprint 17, REFACTOR-030): `pinned_trucks` persiste via
                    // `config/commitChange` granulare (Vue.set per-chiave) invece di
                    // `saveConfig` → MERGE full-reassign → niente cascata. `computedPinnedTrucks`
                    // (getter) ritorna un array fresco filtrato dai truck → nessuno shared-ref
                    // con lo state. NB: il debounce 5s di emitPinTruck già coalesce i pin
                    // ravvicinati; il debounce ~600ms del bus coalesce l'eventuale residuo.
                    this.$store.dispatch('config/commitChange', {
                        key: 'pinned_trucks',
                        value: this.computedPinnedTrucks
                    })
                }, 5000)()
            }
        },
        emitDetailTruckHooked(plate) {
            // REFACTOR-006 (Sprint 7): effectiveTrucks (non this.trucks): la prop `trucks`
            // non è più passata dal desktop, va via store. Vedi computed effectiveTrucks.
            let truck = this.effectiveTrucks.find((t) => t.plate === plate)
            this.emitFocusEvent(truck)
        },
        emitFocusEvent(truck, optional_actions) {
            this.ignore_scroll = true

            // Per la versione mobile il focus viene gestito solo sullo store perchè non vi è il componente padre su cui emettere l'evento
            // Inoltre, se siamo in mobile, viene aperta la pagina di dettaglio del veicolo
            if ((this.$mq == 'xs' || this.$mq == 'sm') && this.direction != 'horizontal') {
                this.$store.commit('setFocusTruck', { truck: truck, on_focus: true })

                this.$router.push({ name: 'geofleet.vehicle_details', params: { id: truck.plate } })
            }

            this.$emit('focus', truck, optional_actions)
        },
        emitActivityEvent(truck) {
            this.ignore_scroll = true

            this.$emit('activity', truck)
        },
        emitPlanEvent(truck) {
            this.ignore_scroll = true

            this.$emit('plan', truck)
        },
        emitManagerEvent(truck) {
            this.ignore_scroll = true

            this.$emit('manager', truck)
        },
        checkActiveCompany(companyId) {
            if (
                Object.keys(this.effectiveCompanies).length > 0 &&
                this.filterCompanies[companyId]
            ) {
                return this.filterCompanies[companyId].active === true
            }
        },
        checkActiveTrucksTags(truckTags, searchedTags) {
            truckTags = truckTags || []

            if (searchedTags.length > 0) {
                let tagsArray = truckTags.map((tag) => tag.id)
                searchedTags = searchedTags.map((tag) => tag.id)

                // check if all tags exist in searchedTags
                var exist = searchedTags.every((tag) => tagsArray.includes(tag))

                return exist
            }
        },
        toggleSorter(target) {
            if (this.sort[target].active === true) {
                // if not already exist, add to sortAction
                let exist = this.sortAction.findIndex((obj) => obj.key === this.sort[target].fields)

                if (exist === -1) {
                    this.sortAction.push({
                        key: this.sort[target].fields,
                        order: this.sort[target].order
                    })
                } else {
                    this.sortAction.splice(exist, 1, {
                        key: this.sort[target].fields,
                        order: this.sort[target].order
                    })
                }
            } else {
                // if not already exist, remove from sortAction
                let exist = this.sortAction.findIndex((obj) => obj.key === this.sort[target].fields)

                if (exist !== -1) {
                    this.sortAction.splice(exist, 1)
                }
            }
        },
        // REFACTOR-025 (Sprint 14): sortByKey/compareByKey estratti in
        // src/functions/sortTrucks.js (condivisi con TrucksTable per il
        // default della vista tabella). `resolvePath` passato come parametro.
        resetFilerFields() {
            clearTimeout(this._filterTrucksTimer)
            this._filterTrucksTimer = null
            this.filterSearchToggle = true

            // Reset filters
            const filters = cloneDeep(defaultFilters)
            this.activeFilters = filters
            this.truckPoiMemberships = {}
            this.$store.dispatch('config/commitChange', {
                key: 'activeFilters',
                value: cloneDeep(filters)
            })

            // Reset near vehicles
            this.nearVehicles.active = false
            this.nearVehicles.areaSearch = null
            this.nearVehicles.vehiclesList = []
            this.nearVehicles.searchLocation = null
            this.nearVehicles.searchResults = []

            // Reset search
            this.q = null

            this.setTruckFilteredOut([])

            // Tolgo dalla pausa l'auto fit bounds della mappa principale
            this.$store.commit('setMainMapStopAutoFitBounds', false)

            return true
        },
        triggerFilter(filter) {
            this.activeFilters[filter] = !this.activeFilters[filter]

            this.filterTrucks(false)
        },
        scheduleFilterTrucks() {
            if (
                this.nearVehicles.searchLocation &&
                this.nearVehicles.areaSearch &&
                !this.nearVehicles.active
            ) {
                return
            }

            clearTimeout(this._filterTrucksTimer)
            this._filterTrucksTimer = setTimeout(() => {
                this._filterTrucksTimer = null
                this.filterTrucks(false, true)
            }, 100)
        },
        async filterTrucks(closeModal, reuseNearbySearch = false) {
            clearTimeout(this._filterTrucksTimer)
            this._filterTrucksTimer = null
            const poiFilterActive =
                (this.activeFilters.poi_id != null && this.activeFilters.poi_id !== '') ||
                (this.activeFilters.poi_category_id != null &&
                    this.activeFilters.poi_category_id !== '')

            // An empty POI collection while loading is not the same as a valid empty result.
            // Keep the current list until the geometry required by the filter is available.
            if (poiFilterActive && !this.poisLoaded) {
                this.loadPoiFilterData()
                return
            }

            this.filterSearchToggle = true

            let truck_filtered_out = []

            let q_reg = this.q ? new RegExp(this.q.trim(), 'i') : null

            let scopedSearch = null
            const activePoiFilters = this.getActivePoiFilters()
            const truckPoiMemberships = {}

            if (this.nearVehicles.searchLocation && this.nearVehicles.areaSearch) {
                scopedSearch =
                    reuseNearbySearch && this.nearVehicles.active
                        ? this.nearVehicles.searchedVehicles
                        : await this.searchNearbyVehicles()
            } else {
                this.nearVehicles.active = false
            }

            for (var truck of this.storeTrucks) {
                // Vehicle alerts building for filtering
                let alerts = buildVehicleAlerts(truck)

                truck.alerts = alerts

                // Query String
                if (q_reg) {
                    if (!truck.q_string) {
                        truck.q_string = ''

                        for (var f of this.q_fields) {
                            var query = this.resolvePath(f, truck)

                            if (query) {
                                truck.q_string += String(query)
                            }
                        }
                    }

                    if (!q_reg.test(truck.q_string)) {
                        truck_filtered_out.push(truck.id)
                        continue
                    }
                }

                // Tags
                if (
                    this.activeFilters.tags.length > 0 &&
                    !this.checkActiveTrucksTags(truck.tags, this.activeFilters.tags)
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Engine RPM ON
                let filter_rpm = parseInt(this.activeFilters.engine_rpm || 0)

                if (
                    filter_rpm == 1 &&
                    (truck.lastpoint.engine_rpm == null || truck.lastpoint.engine_rpm <= 0)
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Engine RPM OFF
                if (filter_rpm == 2 && truck.lastpoint.engine_rpm > 0) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Ignition ON
                if (
                    this.activeFilters.ignition == 1 &&
                    (truck.lastpoint.ignition == null || truck.lastpoint.ignition < 1)
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Ignition OFF
                if (
                    this.activeFilters.ignition == 2 &&
                    (truck.lastpoint.ignition == null || truck.lastpoint.ignition >= 1)
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Low fuel
                if (
                    this.activeFilters.low_fuel === true &&
                    (truck.lastpoint.fuel_level == null ||
                        (truck.lastpoint.fuel_level !== null && truck.lastpoint.fuel_level > 20))
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Low battery
                if (
                    this.activeFilters.low_battery === true &&
                    truck.lastpoint.battery_level !== null &&
                    truck.lastpoint.battery_level > 20
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Tacho overspeed
                if (
                    this.activeFilters.tacho_overspeed === true &&
                    (truck.alerts.tacho_overspeed == null || truck.alerts.tacho_overspeed == false)
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // No power supply
                if (
                    this.activeFilters.no_power_supply === true &&
                    (truck.alerts.no_power_supply == null || truck.alerts.no_power_supply == false)
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // No GPS
                if (
                    this.activeFilters.no_gps === true &&
                    (truck.alerts.no_gps == null || truck.alerts.no_gps == false)
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // No points
                if (
                    this.activeFilters.no_points === true &&
                    (truck.alerts.no_points == null || truck.alerts.no_points == false)
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Tacho clock error — filtro UI unificato → due chiavi granulari nel payload (catch-all by design).
                if (
                    this.activeFilters.tacho_clock_error === true &&
                    !truck.alerts.tacho_clock_from_updated_error &&
                    !truck.alerts.tacho_clock_from_device_error
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Any problem (with low_battery or low_fuel)
                if (
                    this.activeFilters.any_problem === true &&
                    Object.values(truck.alerts).length === 0
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                let speed = parseInt(truck.lastpoint.tacho_speed || truck.lastpoint.speed)

                // Moving vehicles
                if (this.activeFilters.moving == 1 && !isNaN(speed) && speed <= 0) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Stopped vehicles
                if (this.activeFilters.moving == 2 && !isNaN(speed) && speed > 0) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                if (
                    this.activeFilters.activity >= 0 &&
                    this.activeFilters.activity <= 3 &&
                    this.activeFilters.activity !== '' &&
                    truck.lastpoint.activity != this.activeFilters.activity
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                if (
                    this.activeFilters.activity === '' &&
                    truck.lastpoint.activity !== null &&
                    truck.lastpoint.activity !== undefined
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Driving with no card
                if (
                    this.activeFilters.no_card === true &&
                    (truck.type == 3 ||
                        truck.lastpoint.driver == null ||
                        truck.lastpoint.driver.id != 1 ||
                        (truck.lastpoint.driver.id == 1 && speed == 0))
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Codriving
                if (
                    this.activeFilters.codriving === true &&
                    (truck.lastpoint.codriver == null || truck.lastpoint.codriver.id <= 1)
                ) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                // Residual commitment
                if (this.activeFilters.residual_commitment > 0) {
                    let totalDrivingTime = 0

                    totalDrivingTime +=
                        this.driversData[truck.lastpoint?.driver?.id]?.lefts?.today || 0

                    totalDrivingTime +=
                        this.driversData[truck.lastpoint?.codriver?.id]?.lefts?.today || 0

                    if (totalDrivingTime < this.activeFilters.residual_commitment * 60 * 60) {
                        truck_filtered_out.push(truck.id)
                        continue
                    }
                }

                if (scopedSearch && scopedSearch.indexOf(truck.id) == -1) {
                    truck_filtered_out.push(truck.id)
                    continue
                }

                if (poiFilterActive) {
                    const matchingPois = this.getTruckMatchingPois(truck, activePoiFilters)

                    if (matchingPois.length === 0) {
                        truck_filtered_out.push(truck.id)
                        continue
                    }

                    truckPoiMemberships[truck.id] = [
                        ...new Set(
                            matchingPois.map(
                                (poi) => poi.description || poi.type_description || String(poi.id)
                            )
                        )
                    ]
                }

                if (this.activeFilters.branches && this.activeFilters.branches.length > 0) {
                    if (!this.activeFilters.branches.includes(truck.details.branch)) {
                        truck_filtered_out.push(truck.id)
                        continue
                    }
                }

                if (this.activeFilters.sectors && this.activeFilters.sectors.length > 0) {
                    if (!this.activeFilters.sectors.includes(truck.details.sector)) {
                        truck_filtered_out.push(truck.id)
                        continue
                    }
                }
            }

            if (closeModal) this.$bvModal.hide('modal-search-trucks')

            this.truckPoiMemberships = truckPoiMemberships

            if (this.activeSearches > 0 && !this.nearVehicles.active) {
                this.$store.commit('setMainMapStopAutoFitBounds', true)
            }

            this.setTruckFilteredOut(truck_filtered_out)
        },
        async searchNearbyVehicles() {
            this.nearVehicles.active = true

            let area = this.nearVehicles.areaSearch
            let lat = this.nearVehicles.searchLocation.referenceCoordinate.y
            let lng = this.nearVehicles.searchLocation.referenceCoordinate.x
            let results = []

            let url =
                this.$env.GOLIA_API +
                '/trucks?include[]=lastpoint&filter[VISIBILE][eq]=1&area[lat]=' +
                lat +
                '&area[lng]=' +
                lng +
                '&area[r]=' +
                area

            results = await this.$fetch(url)
                .then((res) => {
                    return res.json()
                })
                .then((res) => {
                    return res.data.map((truck) => truck.id)
                })

            this.nearVehicles.searchedVehicles = results
            return results
        },
        searchTrucks: debounce((newV, vm) => {
            vm.q = newV

            vm.filterTrucks(false)
        }, 500),
        // Consume the one-shot "find near vehicles" seed from the map context
        // menu: pre-fill the nearby-search location and open the filter modal so
        // the user can confirm/adjust the radius before searching.
        consumeNearVehiclesSeed() {
            const seed = this.nearVehiclesSeed
            if (!seed?.location) return false

            this.nearVehicles.searchLocation = seed.location
            this.filterActiveTab = 3
            this.clearNearVehiclesSeed()

            this.$nextTick(() => this.$bvModal.show('modal-search-trucks'))
            return true
        },
        ...mapMutations({
            setTruckFilteredOut: 'setTruckFilteredOut',
            toggleCollapsePanel: 'toggleCollapsePanel',
            clearNearVehiclesSeed: 'clearNearVehiclesSeed'
        })
    },
    watch: {
        // Map context-menu "find near vehicles": seed usually arrives while this
        // persistent panel is already mounted, so react to it here.
        nearVehiclesSeed(seed) {
            if (seed?.location) this.consumeNearVehiclesSeed()
        },
        // REFACTOR-007 (Sprint 7): lo scroll della lista sul truck in focus arriva
        // dal bus dello store invece che dalla chiamata imperativa
        // $refs.main_panel.truckFocus() fatta da GeoFleet. Il metodo truckFocus
        // (e la logica ignore_scroll) resta invariato: cambia solo il trigger.
        getFocusRequest(req) {
            if (!req || !req.truck) return
            this.truckFocus(req.truck)
        },
        effectiveCompanies: {
            handler: function (val) {
                if (Object.keys(val).length > 0) {
                    this.filterCompanies = Object.assign({}, val)

                    for (const i in this.filterCompanies) {
                        this.filterCompanies[i] = { name: this.filterCompanies[i], active: true }
                    }
                }
            }
        },
        filterCompanies: {
            handler: function () {
                // REFACTOR-010 (Fase 4): deep:true CONSERVATO — `checkActiveCompany`
                // legge `filterCompanies[companyId].active` (nested boolean), che muta
                // quando l'utente toggla un filtro company nella UI. Senza deep:true,
                // la mutation nested non triggera il watcher e il filtro non si applica.
                // Riduzione possibile (scope future): watchare un computed che derivi
                // solo gli array `activeCompanyIds: filterCompanies.filter(c => c.active).map(c => c.id)`
                // e watchare quel computed con `deep: false`. Vedi INVESTIGATION-001.

                // migrate this to a method
                let truck_filtered_out = []

                if (Object.keys(this.effectiveCompanies).length > 0) {
                    for (var truck of this.storeTrucks) {
                        if (
                            (truck.details.secondary_company !== null &&
                                !this.checkActiveCompany(truck.details.secondary_company)) ||
                            (truck.details.secondary_company === null &&
                                !this.checkActiveCompany(truck.details.company))
                        ) {
                            truck_filtered_out.push(truck.id)
                        } else if (truck_filtered_out.indexOf(truck.id) > -1) {
                            truck_filtered_out.splice(truck_filtered_out.indexOf(truck.id), 1)
                        }
                    }

                    this.setTruckFilteredOut(truck_filtered_out)
                }
            },
            deep: true
        },
        // REFACTOR-009 (Fase 3): RIMOSSI 6 watcher deep:true:
        // - trucks (prop): sync verso localTrucks — non serve, effectiveTrucks reattivo
        // - drivers (prop): sync verso localDrivers — idem
        // - companies (prop): sync verso localCompanies — idem
        // - sortAction (deep): mutava localTrucks.sort() in place — listActiveTrucks
        //   già esegue il sort via [...filtered].sort() reattivo
        // - activeFilters (deep): settava truck.visible=true (dead code, mai falsificato
        //   altrove; e .length su un object initial-stato sempre 0)
        // - storeTrucks (parziale): rimossa la sync `this.localTrucks = val`,
        //   preservata la logica filterTrucks (vedi sotto)
        storeTrucks: {
            // REFACTOR-010 (Fase 4): RIMOSSO deep:true. Il handler legge solo
            // `this.storeTrucks.length` + `this.storedActiveFilters` + flags
            // booleane — niente dentro le entries di storeTrucks. Con deep:true,
            // Vue 2 piazzava un observer su OGNI proprietà di OGNI truck (~660 su
            // tenant grossi × ~30 prop per truck = 20k observer extra senza
            // benefit). Le mutation immutabili (setTrucks/mergeTrucksDelta/
            // appendTruck) cambiano la reference dell'array → il watcher triggera
            // comunque ad ogni cambio rilevante, ma SENZA il walking nested.
            handler: function () {
                if (this.storeTrucks.length === 0) return

                if (!this.filterSearchToggle && this.storedActiveFilters) {
                    this.activeFilters = {
                        ...cloneDeep(defaultFilters),
                        ...cloneDeep(this.storedActiveFilters)
                    }
                }

                if (this.filterSearchToggle || this.storedActiveFilters) {
                    // Reapply filters before Vue renders the merged lastpoints,
                    // otherwise excluded markers are visible for one frame.
                    this.filterTrucks(false, true)
                }
            }
        },
        storedActiveFilters: {
            handler(filters) {
                if (!filters) return

                if (!this.filterSearchToggle) {
                    this.activeFilters = {
                        ...cloneDeep(defaultFilters),
                        ...cloneDeep(filters)
                    }
                }

                if (this.storeTrucks.length > 0) this.scheduleFilterTrucks()
            }
        },
        storePois() {
            const poiFilterActive =
                (this.activeFilters.poi_id != null && this.activeFilters.poi_id !== '') ||
                (this.activeFilters.poi_category_id != null &&
                    this.activeFilters.poi_category_id !== '')

            if (poiFilterActive && this.poisLoaded) this.scheduleFilterTrucks()
        },
        poisLoaded(loaded) {
            const poiFilterActive =
                (this.activeFilters.poi_id != null && this.activeFilters.poi_id !== '') ||
                (this.activeFilters.poi_category_id != null &&
                    this.activeFilters.poi_category_id !== '')

            if (loaded && poiFilterActive) this.scheduleFilterTrucks()
        },
        q(newV) {
            this.searchTrucks(newV, this)
        }
    },
    computed: {
        // On a phone the panel fills the screen whatever the setting says, so
        // "Dynamic width" is ignored there (and hidden in the settings).
        isMobile() {
            return this.$mq == 'xs' || this.$mq == 'sm'
        },
        fluidTable() {
            return this.vehicleListFluidTable && !this.isMobile
        },
        // REFACTOR-009 (Fase 3): "effective" = prop se fornita, altrimenti store.
        // Sostituisce il pattern data + watcher di sync (localTrucks/Drivers/Companies)
        // con computed reattivi. Single source of truth = store, override via props
        // per casi sharedLink/embed che passano dati custom.
        effectiveTrucks() {
            return this.trucks && this.trucks.length > 0 ? this.trucks : this.storeTrucks
        },
        effectiveDrivers() {
            return this.drivers && Object.keys(this.drivers).length > 0
                ? this.drivers
                : this.storeDrivers
        },
        effectiveCompanies() {
            return this.companies && Object.keys(this.companies).length > 0
                ? this.companies
                : this.storeCompanies
        },
        visibleTrucks() {
            return this.effectiveTrucks.filter((truck) => truck.visible).length
        },
        listActiveTrucks() {
            // REFACTOR-026 (Sprint 13): Set per il lookup O(1) (vedi GeoFleet.vue) → O(N+M)
            const filteredOut = new Set(this.truck_filtered_out)
            const filteredTrucks = this.effectiveTrucks.filter(
                (truck) => !filteredOut.has(truck.id) && !truck.pinned
            )

            // REFACTOR-025 (Sprint 14): in vista tabella l'ordine è di competenza di
            // TrucksTable (sortAction come default + sorted_field per colonna,
            // che ri-ordina comunque) → qui NON ordiniamo, per non sortare due volte
            // gli stessi dati ad ogni tick. La vista lista (recycle-scroller) usa
            // invece questo sort.
            if (this.vehicleListModeView == 'table') {
                return filteredTrucks
            }

            if (this.sortAction.length > 0) {
                // SORTER (REFACTOR-009: sort puro su un clone shallow, non muta
                // più state.trucks direttamente — Array.sort mutates in place).
                return [...filteredTrucks].sort(sortByKey(this.sortAction, this.resolvePath))
            }
            return filteredTrucks
        },
        companyCounts() {
            const counts = {}

            for (const companyId in this.effectiveCompanies) {
                counts[companyId] = 0
            }

            this.storeTrucks.forEach((truck) => {
                const companyId = truck.details.secondary_company || truck.details.company

                if (companyId in counts) {
                    counts[companyId]++
                }
            })

            return counts
        },
        activeSearches() {
            let counter = 0

            this.activeFilters?.tags?.length > 0 ? counter++ : null
            this.activeFilters.activity != 4 ? counter++ : null
            this.activeFilters.engine_rpm > 0 ? counter++ : null
            this.activeFilters.ignition > 0 ? counter++ : null
            this.activeFilters.low_fuel === true ? counter++ : null
            this.activeFilters.moving > 0 ? counter++ : null
            this.activeFilters.no_card === true ? counter++ : null
            this.activeFilters.codriving === true ? counter++ : null
            this.activeFilters.residual_commitment > 0 ? counter++ : null
            this.activeFilters.branches && this.activeFilters.branches.length > 0 ? counter++ : null
            this.activeFilters.sectors && this.activeFilters.sectors.length > 0 ? counter++ : null
            this.activeFilters.poi_category_id || this.activeFilters.poi_id ? counter++ : null

            if (this.nearVehicles.active) {
                counter++
            }

            return counter
        },
        sortedFields() {
            var fields = 0

            for (var key in this.sort) {
                if (this.sort[key] > 0) {
                    fields++
                }
            }

            return fields
        },
        computedPinnedTrucks: {
            get() {
                return this.effectiveTrucks.filter((truck) => truck.pinned)
            },
            set(storePinnedTrucks) {
                // REFACTOR-009 (Fase 3): mutazione diretta su truck.pinned preservata
                // (era già il pattern pre-Sprint-6 via localTrucks shared ref); con
                // l'eliminazione di localTrucks la write avviene direttamente sul
                // truck dello state.geoFleet.trucks. Risulta in una violazione di
                // Vuex strict mode (mutate-outside-mutation) ma è comportamento
                // identico a prima. Migrazione a setPinnedTrucks mutation è scope
                // separato (REFACTOR successivo, fuori dal triplo storage).
                this.effectiveTrucks.map((truck) => {
                    truck.pinned = storePinnedTrucks.find(
                        (storePinnedTruck) => storePinnedTruck.id == truck.id
                    )
                        ? true
                        : false
                })
            }
        },
        // Sprint 19: reader granulari dal Config Bus (default da schema: vehicleListModeView
        // → 'list', sostituisce il fallback inline del vecchio computed hand-rolled).
        ...mapConfig([
            'vehicleListModeView',
            'vehicleListFluidTable',
            'vehicleIdentification',
            'pinned_trucks'
        ]),
        ...mapState({
            // Sprint 19: `sort` e `activeFilters` collidono con identificatori locali e hanno
            // hydration custom present-check (il default schema non è load-bearing): si legge
            // la sotto-chiave NUDA dallo state (granulare; assente → undefined come nel legacy,
            // reference stabile → niente fire spurî dei watcher, vedi decision Sprint 19).
            storedActiveFilters: (state) => state.config.user.activeFilters,
            storedSort: (state) => state.config.user.sort,
            storeTrucks: (state) => state.geoFleet.trucks,
            storeDrivers: (state) => state.geoFleet.drivers,
            storeCompanies: (state) => state.geoFleet.companies,
            sharedLinks: (state) => state.sharedLinks.links,
            driversData: (state) => state.geoFleet.driversData,
            truck_filtered_out: (state) => state.geoFleet.truckFilteredOut,
            nearVehiclesSeed: (state) => state.geoFleet.nearVehiclesSeed,
            storePois: (state) => state.pois.pois,
            poisLoaded: (state) => state.pois.poisLoaded,
            poiCategories: (state) => state.pois.poiCategories
        }),
        ...mapGetters({
            driversDataArray: 'getArrayOfDriversData',
            mainCollapsed: 'mainCollapsed',
            getTrucksWithAlerts: 'getTrucksWithAlerts',
            getFocusRequest: 'getFocusRequest'
        })
    },
    created() {
        this.activeFilters = this.storedActiveFilters
            ? {
                  ...cloneDeep(defaultFilters),
                  ...cloneDeep(this.storedActiveFilters)
              }
            : cloneDeep(defaultFilters)

        // REFACTOR-009 (Fase 3): rimossa chiamata a loadData() — i computed
        // effective* sono reattivi automaticamente.

        // Load pinned trucks from store
        if (this.pinned_trucks && this.pinned_trucks.length > 0) {
            this.computedPinnedTrucks = this.pinned_trucks
        }

        // A seed set before this panel mounted (rare, since MainPanel persists).
        this.consumeNearVehiclesSeed()
    },
    mounted() {
        this.$watch(
            () => this.storedSort,
            (val) => {
                this.sort = val

                for (const key in val) {
                    this.toggleSorter(key)
                }
            }
        )
    },
    beforeDestroy() {
        clearTimeout(this._filterTrucksTimer)
    }
}
</script>

<style lang="scss">
.btn-scroll-vehicles {
    position: absolute;
    bottom: 0px;
    right: calc(100% + 15px);
    background: #fff;
    opacity: 0;
    height: 0px;
    transition: all 0.3s ease-in-out;
    min-width: 200px;

    &.animated {
        height: auto;
        opacity: 1;
        transition: all 0.5s;
    }
}
.btn-close-scroll-vehicles {
    margin: 0 auto 15px;
    transform: translateX(15px);
    display: block;

    i {
        font-size: 12px;
    }
}
#modal-search-trucks {
    .form-control,
    .form-select {
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .btn {
        border-radius: 12px;
        padding-top: 8px;
        padding-bottom: 8px;
    }
}
</style>

<style scoped lang="scss">
@use 'MainPanel/styles/MainPanel.scss';
</style>
